import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Apa yang Baru: penyimpan kecil yang dipakai bersama oleh popup dan titik
 * merah di menu. Daftar belum-dibaca diambil SATU KALI per sesi login (tanpa
 * polling) lalu dibagikan ke semua pemakai lewat langganan sederhana.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let state = { items: [], count: 0, loaded: false };
let inflight = null;
let generation = 0; // naik tiap reset, supaya respons milik user lama dibuang
const listeners = new Set();

function emit() {
  listeners.forEach((fn) => fn(state));
}

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : null;
}

export function loadAppUpdates(force = false) {
  const headers = authHeaders();
  if (!headers) return Promise.resolve(state);
  if (state.loaded && !force) return Promise.resolve(state);
  if (inflight) return inflight;
  const myGen = generation;
  inflight = axios
    .get(`${API}/app-updates/unread`, { headers })
    .then((res) => {
      if (myGen !== generation) return state; // user sudah ganti/logout
      const d = res.data || {};
      state = { items: d.items || [], count: d.count || 0, loaded: true };
      emit();
      return state;
    })
    .catch(() => state) // diam saja, fitur ini tidak boleh mengganggu
    .finally(() => {
      if (myGen === generation) inflight = null;
    });
  return inflight;
}

export function resetAppUpdates() {
  generation += 1;
  inflight = null;
  state = { items: [], count: 0, loaded: false };
  emit();
}

export async function markAppUpdatesRead(ids) {
  const headers = authHeaders();
  const clean = (ids || []).filter(Boolean);
  if (!headers || clean.length === 0) return;
  try {
    await axios.post(`${API}/app-updates/mark-read`, { ids: clean }, { headers });
  } catch (e) {
    return; // gagal simpan: jangan hapus dari daftar, akan muncul lagi nanti
  }
  const gone = new Set(clean);
  const items = state.items.filter((i) => !gone.has(i.id));
  const removed = state.items.length - items.length;
  // Jumlah total bisa lebih besar dari yang tampil di popup (maks 5), jadi
  // ambil ulang dari server supaya sisanya muncul di buka berikutnya.
  state = { items, count: Math.max(0, state.count - removed), loaded: true };
  emit();
  loadAppUpdates(true);
}

export function useAppUpdates() {
  const [snap, setSnap] = useState(state);
  useEffect(() => {
    listeners.add(setSnap);
    setSnap(state);
    loadAppUpdates();
    return () => {
      listeners.delete(setSnap);
    };
  }, []);
  return snap;
}
